<template>
  <div class="service_order_container">
    <div class="box_shadow_wrap">
      <div class="global_title">需求订单</div>

      <!-- 查询表单 start -->
      <a-form class="query_form" layout="inline">
        <a-form-item label="需求订单">
          <a-input v-model="supplyDetail" placeholder="请输入订单描述" allow-clear />
        </a-form-item>
        <a-form-item label="订单日期">
          <a-date-picker v-model="dateString" @change="onChange" />
        </a-form-item>
        <a-form-item class="query_btn">
          <a-button type="primary" class="btn_lightgreen" icon="search" @click="getTabelData">
            查询
          </a-button>
          <a-button type="primary" style="margin-left: 10px" icon="redo" @click="resetForm">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 查询表单 end -->
    </div>

    <div class="box_shadow_wrap tabs_wrap">
      <a-tabs :tabBarGutter="0" :animated="false" :default-active-key="tabIndex" @change="callback">
        <a-tab-pane
          :key="index"
          :tab="`${item}(${countList[index]})`"
          v-for="(item, index) in tabs"
        >
          <!-- 表格 start -->
          <a-table :columns="columns" :data-source="tabelData" row-key="id" :scroll="{ x: 1300, y: 340 }" :loading="isLoading" :pagination="false">
            <template slot="order" slot-scope="text, record">
              <img :title="record.supplyDetail" class="table_img" :src="record.supplyPicture | ossComplete">
              <span :title="record.supplyDetail" style="margin-left: 10px; white-space: nowrap; vertical-align: middle;" v-if="record.supplyDetail">{{record.supplyDetail}}</span>
            </template>
            <template slot="progressStatus" slot-scope="text, record">
              <template v-if="record.status == 2">
                <span class="link_color"><a-icon type="check-circle" :style="{ marginRight: '5px' }" />已完成</span>
              </template>
              <template v-else>
                <span class="ant-btn-link">{{record.progress || '暂无进度'}}</span><br>
                <span v-if="record.estimatedFinishTime">预计完成：{{record.estimatedFinishTime}}</span>
              </template>
            </template>
            <template slot="cancelType" slot-scope="text">
                {{ text == 0 ? '买方取消' : '卖方取消' }}
            </template>
            <template slot="handle" slot-scope="text, record">
              <template v-if="record.status == 0">
                <a-button class="table_btn link_color" type="link" @click="clickHandle(7, record)">查看</a-button>
                <a-divider type="vertical" />
                <a-button class="table_btn link_color" type="link" @click="clickHandle(1, record)">修改</a-button>
                <a-divider type="vertical" />
                <a-button class="table_btn link_color" type="link" @click="clickHandle(2, record)">取消</a-button>
              </template>
              <template v-if="record.status == 1">
                <a-button class="table_btn link_color" type="link" @click="clickHandle(7, record)">查看</a-button>
                <a-divider type="vertical" />
                <a-button class="table_btn link_color" type="link" @click="clickHandle(3, record)">评价</a-button>
              </template>
              <template v-if="record.status == 2">
                <a-button class="table_btn link_color" type="link" @click="clickHandle(4, record)">查看评价</a-button>
              </template>
              <template v-if="record.status == 3">
                <a-button class="table_btn link_color" type="link" @click="clickHandle(7, record)">查看</a-button>
                <a-divider type="vertical" />
                <a-button class="table_btn link_color" type="link" @click="clickHandle(6, record)">重新下单</a-button>
              </template>
            </template>
          </a-table>
          <!-- 表格 end -->
        </a-tab-pane>
      </a-tabs>

      <!-- 分页 -->
      <div class="pagination_wrap">
        <a-space>
          <a-pagination 
          show-quick-jumper 
          show-size-changer
          :total="total" 
          :show-total="total => `共有 ${total} 条`"
          :page-size-options="pageSizeOptions"
          :page-size="size"
          v-model="page"
          @showSizeChange="onShowSizeChange"
          @change="changePage">
            <template slot="buildOptionText" slot-scope="props">
              <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
              <span v-if="props.value === '50'">全部</span>
            </template>
          </a-pagination>
          <a-button>确定</a-button>
        </a-space>
      </div>
    </div>

    <!-- 维护服务进度对话框 starat -->
    <a-modal v-model="visible" :title="modalTitle" destroyOnClose on-ok="handleOk">
      <template slot="footer">
        <template v-if="activetdIndex == 4">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button key="submit" class="btn_lightgreen" :loading="loading" @click="addComment">
            追加评价
          </a-button> 
        </template>
        <template v-else-if="activetdIndex == 7">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
        </template>
        <template v-else>
          <a-button key="back" @click="handleCancel">
            取消
          </a-button>
          <a-button key="submit" class="btn_lightgreen" :loading="loading" @click="handleOk">
            确定
          </a-button> 
        </template>
      </template>
      <a-form-model :class="[activetdIndex == 1 || activetdIndex == 6 || activetdIndex == 7 ? 'space_from' : '']" ref="ruleForm" :model="orderDetail" :rules="rules" v-bind="formModalLayout">
        <a-form-model-item label="需求订单">
          <div class="order_info_wrap">
            <img class="img" style="vertical-align: top;" :src="orderDetail.supplyPicture | ossComplete">
            <div class="order_info">
              <div>{{orderDetail.supplyDetail}}</div>
              <div class="order_time">下单时间：{{orderDetail.orderTime}}</div>
              <div class="supplier_wrap"><img class="store_ico" src="../../../assets/img/store.png">{{orderDetail.supplier}}</div>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item :required="activetdIndex == 1 || activetdIndex == 6" label="联系人" prop="contacts">
          <a-input v-model="orderDetail.contacts" placeholder="请输入联系人" v-if="activetdIndex == 1 || activetdIndex == 6" />
          <span v-else>{{orderDetail.contacts}}</span>
        </a-form-model-item>
        <a-form-model-item :required="activetdIndex == 1 || activetdIndex == 6" label="联系方式" prop="phone">
          <a-input v-model.number="orderDetail.phone" placeholder="请输入联系方式" v-if="activetdIndex == 1 || activetdIndex == 6" />
          <span v-else>{{orderDetail.phone}}</span>
        </a-form-model-item>
        <a-form-model-item label="给卖家留言" v-if="orderDetail.message || activetdIndex == 1 || activetdIndex == 6 || activetdIndex == 7">
          <a-textarea v-model="orderDetail.message" style="margin-top: 4px;" placeholder="请输入留言内容" :rows="4" allow-clear v-if="activetdIndex == 1 || activetdIndex == 6" />
          <div style="line-height: normal; padding: 10px 0;" v-else>{{orderDetail.message}}</div>
        </a-form-model-item>
        <a-form-model-item label="单据说明" v-if="progressImage.length">
          <bj-upload :default-list="progressImage" :disabled="true" :action="uploadUrl" :max="progressImage.length"></bj-upload>
        </a-form-model-item>
        <a-divider v-if="activetdIndex !== 1 && activetdIndex !== 6 && activetdIndex !== 7" />
        <template v-if="activetdIndex == 2">
          <a-form-model-item required label="取消原因" prop="cancelReason">
            <a-textarea v-model="orderDetail.cancelReason" placeholder="请输入取消原因" :rows="4" allow-clear />
          </a-form-model-item>
        </template>
        <template v-if="activetdIndex == 3 || activetdIndex == 4 || activetdIndex == 5">
          <a-form-model-item label="订单评价" prop="evaluate" v-if="activetdIndex == 3">
            <a-rate v-model="orderDetail.evaluate" />
          </a-form-model-item>
          <a-form-model-item label="订单评价" v-else>
            <a-rate :default-value="orderDetail.evaluate" disabled />
          </a-form-model-item>
          <a-form-model-item label="评价描述" v-if="activetdIndex == 3 || orderDetail.evaluateDescription">
            <a-textarea v-model="orderDetail.evaluateDescription" placeholder="从多个角度评价服务，可能帮助更多需要帮助的人" :rows="4" allow-clear v-if="activetdIndex == 3" />
            <div style="line-height: normal; padding: 10px 0;" v-else>{{orderDetail.evaluateDescription}}</div>
          </a-form-model-item>
          <a-form-model-item class="margin_bottom" label="上传图片" :wrapperCol="{ span: 18 }">
            <div class="clearfix" v-if="activetdIndex == 3">
              <bj-upload :action="uploadUrl" @change="uploadList"></bj-upload>
              <div class="tips">文件必须是JPG或PNG格式的图片<br>最多上传5张<br>每个文件大小不超过5M，尺寸比例为1:1</div>
            </div>
            <template v-else>
              <bj-upload :default-list="evaluateImgs" :disabled="true" :action="uploadUrl" :max="evaluateImgs.length"></bj-upload>
            </template>
          </a-form-model-item>
        </template>
        <template v-if="activetdIndex == 4 || activetdIndex == 5">
          <a-form-model-item class="margin_bottom" :wrapperCol="{ span: 24 }" v-if="orderDetail.replyList.length > 0">
            <div class="comment" v-for="(item, index) in orderDetail.replyList" :key="index">[ {{item.type == 1 ? '评价' : '回复'}} ]{{item.createdTime}}：{{item.content}}</div>
          </a-form-model-item>
          <a-form-model-item label="追加评价" v-if="activetdIndex == 5" prop="content">
            <a-textarea v-model="orderDetail.content" placeholder="请输入评价内容" :rows="4" allow-clear />
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
    <!-- 维护服务进度对话框 end -->

  </div>
</template>
<script>
import { ApiUrl } from '@/config/index'
const columns = [
  {
    title: '需求订单',
    dataIndex: 'order',
    key: 'order',
    ellipsis: true,
    scopedSlots: { customRender: 'order' }
  },
  {
    title: '供应方',
    dataIndex: 'supplier',
    key: 'supplier',
    ellipsis: true
  },
  {
    title: '下单时间',
    dataIndex: 'orderTime',
    key: 'orderTime',
  },
  {
    title: '服务进度',
    key: 'progressStatus',
    dataIndex: 'progressStatus',
    scopedSlots: { customRender: 'progressStatus' },
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    scopedSlots: { customRender: 'handle' },
    fixed: 'right'
  },
];

const columns2 = [
  {
    title: '需求订单',
    dataIndex: 'order',
    key: 'order',
    ellipsis: true,
    scopedSlots: { customRender: 'order' }
  },
  {
    title: '供应方',
    dataIndex: 'supplier',
    key: 'supplier',
    ellipsis: true
  },
  {
    title: '下单时间',
    dataIndex: 'orderTime',
    key: 'orderTime',
  },
  {
    title: '服务进度',
    key: 'progressStatus',
    dataIndex: 'progressStatus',
    scopedSlots: { customRender: 'progressStatus' },
  },
  {
    title: '状态',
    dataIndex: 'cancelType',
    key: 'cancelType',
    scopedSlots: { customRender: 'cancelType' },
  },
  {
    title: '取消原因',
    dataIndex: 'cancelReason',
    key: 'cancelReason',
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    scopedSlots: { customRender: 'handle' },
    fixed: 'right'
  },
];


export default {
  name: "demandOrder",
  data() {
    const validateCancelReason = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入取消原因'));
      } else {
        callback();
      }
    }
    
    const validateContacts = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系人'));
      } else {
        callback();
      }
    }

    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'));
      } else if (!this.$utils.test.mobile(value)) {
        callback(new Error('电话证格式错误'));
      } else {
        callback();
      }
    }

    const validateEvaluate = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('请选择评价描述'));
      } else {
        // const str = this.activetdIndex == 5 ? this.content : this.orderDetail.evaluateDescription

        callback();
      }
    }

    const validateContent = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入评价内容'));
      } else {
        callback();
      }
    }

    return {
      uploadUrl: `${ApiUrl}/api/backapp/system/fileUpload/oss/input`,
      tabs: ["全部", "执行中", "待评价", "已完成", "已取消"],
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      countList: [0, 0, 0, 0, 0],
      tabIndex: 0,
      loading: false,
      visible: false,
      formModalLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 17
        },
      },
      activetdIndex: 1,
      page: 1,
      size: 10,
      total: 0,
      rate: 0,
      isLoading: false,
      tabelData: [],
      supplyDetail: '',
      orderTime: '',
      dateString: '',
      content: '',
      orderDetail: {},
      rules: {
        contacts: [{ validator: validateContacts, trigger: 'change' }],
        phone: [{ validator: validatePhone, trigger: 'change' }],
        evaluate: [{ validator: validateEvaluate, trigger: 'change' }],
        cancelReason: [{ validator: validateCancelReason, trigger: 'change' }],
        content: [{ validator: validateContent, trigger: 'change' }]
      },
      img64:'data:image/png;base64,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',
    };
  },
  computed: {
    modalTitle() {
      if (this.activetdIndex === 1) return '确认订单信息'
      else if (this.activetdIndex === 2) return '取消订单'
      else if (this.activetdIndex === 3) return '评价订单'
      else if (this.activetdIndex === 4) return '订单评价'
      else if (this.activetdIndex === 5) return '追加评价'
      else if (this.activetdIndex === 6) return '确认订单信息'
      else return '订单详情'
    },
    evaluateImgs() {
      if (this.orderDetail.evaluatePicture) {
        const arr = this.orderDetail.evaluatePicture.split(';') || []
        return arr.map((item, index) => ({uid: `-${index + 1}`, name: 'image.png', status: 'done', url: item}))
      } else {
        return []
      }
    },
    progressImage() {
      if (this.orderDetail.progressImage) {
        const arr = this.orderDetail.progressImage.split(';') || []
        return arr.map((item, index) => ({uid: `-${index + 1}`, name: 'image.png', status: 'done', url: item}))
      } else {
        return []
      }
    },
    columns() {
      return this.tabIndex === 4 ? columns2 : columns
    }
  },
  created() {
    if (this.$route.query.status) this.tabIndex = Number(this.$route.query.status) || 0
    this.getDemandCount()
    this.getOrderList()
  },
  methods: {
    // 获取订单数量
    async getDemandCount() {
      this.isLoading = true
      const { data: { code, msg, body } } = await this.$axios.getDemandOrderCount({body: {params:{
        supplyDetail: this.supplyDetail, // 需求订单详情
        orderTime: this.orderTime // 订单下单时间
      }}})
      this.isLoading = false
      if (code != 0) return this.$message.error(msg)
      this.countList = [
        body.total || 0,
        body.processing || 0,
        body.waitValuate || 0,
        body.finished || 0,
        body.canceled || 0
      ]
    },
    // 获取订单列表数据
    async getOrderList() {
      let status = ''
      if (this.tabIndex == 0) status = '!=3'
      else if (this.tabIndex == 1) status = '0'
      else if (this.tabIndex == 2) status = '1'
      else if (this.tabIndex == 3) status = '2'
      else if (this.tabIndex == 4) status = '3'
      
      this.isLoading = true
      const { data: { code, msg, body } } = await this.$axios.getDemandOrderList({
        body:{
          pageNum: this.page,
          pageSize: this.size,
          orders: "",   
          params: {
            supplyDetail: this.supplyDetail, // 需求订单详情
            orderTime: this.orderTime, // 订单下单时间
            status: status // 0：执行中 1：待评价 2：已完成 :3:已取消
          }
        }
      })
      this.isLoading = false
      if (code != 0) return this.$message.error(msg)
      this.tabelData = body.dataList || []
      this.total = Number(body.totalCount)
    },
    // 评价订单
    async evaluateOrder() {
      const str = this.activetdIndex == 5 ? this.orderDetail.content : this.orderDetail.evaluateDescription
      const { data: { code, msg } } = await this.$axios.evaluateDemandOrder({
        body: {
            id: this.orderDetail.id, // 订单id
            evaluate: this.orderDetail.evaluate, // 评价
            evaluatePicture: this.orderDetail.evaluatePicture, // 评价图片
            evaluateDescription: str // 评价描述
        }
      })
      if (this.activetdIndex == 5) this.content = ''
      if (code != 0) return this.$message.error(msg)
    },
    // 修改订单
    async modifyOrder() {
      const { data: { code, msg } } = await this.$axios.modifyDemandOrder({
        body: {
            id: this.orderDetail.id, // 订单id
            supplyId: this.orderDetail.supplyId, // 供应id
            contacts: this.orderDetail.contacts, //  联系人
            phone: this.orderDetail.phone, // 联系方式
            message: this.orderDetail.message //买家留言
        }
      })
      if (code != 0) return this.$message.error(msg)
      this.$message.success('修改成功')
    },
    // 取消订单
    async cancelOrder() {
      const { data: { code, msg } } = await this.$axios.cancelDemandOrder({
        body: {
            id: this.orderDetail.id, // 订单id
            cancelReason: this.orderDetail.cancelReason // 取消原因
        }
      })
      if (code != 0) return this.$message.error(msg)
      this.$message.success('取消成功')
    },
    // 重新下单
    async demandReorderById() {
      const { data: { code, msg } } = await this.$axios.demandReorder({
        body: {
            id: this.orderDetail.id, // 订单id
            supplyId: this.orderDetail.supplyId, // 供应id
            contacts: this.orderDetail.contacts, //  联系人
            phone: this.orderDetail.phone, // 联系方式
            message: this.orderDetail.message //买家留言
        }
      })
      if (code != 0) return this.$message.error(msg)
      this.$message.success('下单成功')
    },
    // 选择时间
    onChange(date, dateString) {
      this.orderTime = dateString ? `${dateString} 00:00:00` : dateString
    },
    // tab选项卡切换
    callback(key) {
      this.tabIndex = key
      this.page = 1
      this.size = 10
      this.getDemandCount()
      this.getOrderList()
    },
    // 分页
    changePage(page, pageSize) {
      this.page = page
      this.size = pageSize
      this.getOrderList()
    },
    // 每页数量
    onShowSizeChange(current, pageSize) {
      this.page = current
      this.size = pageSize
      this.getOrderList()
    },
    // 点击表格操作列
    clickHandle(res, item = {}) {
      this.activetdIndex = res
      const obj = JSON.parse(JSON.stringify(item))

      // 修改订单
      if (res == 6) {
        obj.contacts = ''
        obj.phone = ''
        obj.message = ''
      }

      // 取消订单
      if (res == 2) {
        obj.cancelReason = ''
      }

      // 评论订单
      if (res == 3) {
        obj.evaluate = 0
        obj.evaluateDescription = ''
        obj.evaluatePicture = ''
      }
      this.orderDetail = obj
      this.showModal()
    },
    // 追加评价 
    addComment() {
      this.$set(this.orderDetail, 'content', '')
      this.activetdIndex = 5
    },
    // 显示模态框
    showModal() {
      this.visible = true;
    },
    // 点击模态框确定按钮
    handleOk() {
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return false

        this.loading = true;
        if (this.activetdIndex == 1) await this.modifyOrder()
        if (this.activetdIndex == 2) await this.cancelOrder()
        if (this.activetdIndex == 3 || this.activetdIndex == 5) await this.evaluateOrder()
        if (this.activetdIndex == 6) await this.demandReorderById()
        this.getDemandCount()
        this.getOrderList()
        this.visible = false;
        this.loading = false;
        
      });
      
    },
    // 关闭模态框
    handleCancel() {
      this.visible = false;
    },
    // 点击查询
    getTabelData() {
      this.getDemandCount()
      this.getOrderList()
    },
    // 图片上传
    uploadList(e) {
      this.orderDetail.evaluatePicture = e
    },
    // 重置
    resetForm() {
      this.supplyDetail = ''
      this.orderTime = ''
      this.dateString = ''
      this.getTabelData()
    }
  },
};
</script>
<style lang="less" scoped>
@import '../../../styles/pages/personalcenter.less';
.service_order_container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 2px;
  .tabs_wrap {
    flex: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 16px;
  }
}
.global_title {
  position: relative;
  padding-left: 10px;
  font-size: 15px;
  font-weight: bold;
  line-height: normal
}
.global_title::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 4px;
  height: 70%;
  box-shadow: 0 0 4px lightgreen;
  background-color: @primary-color;
}
.box_shadow_wrap {
  margin: 0 5px;
  padding: 16px;
  box-shadow: 0px 2px 5px 2px rgba(202, 221, 247, 0.8);
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  color: @link-color;
  &::before {
    border-color: @link-color;
  }
}
/deep/ .ant-table-body {
  overflow-y: auto!important;
}
.btn_lightgreen {
  color: #fff;
  border-color: @primary-color;
  background-color: @primary-color;
}
.tips {
  line-height: normal;
  color: #ccc;
}
.comment {
  padding: 10px;
  line-height: normal;
  background-color: #FDF9FC;
  &:nth-child(n + 2) {
    margin-top: 5px;
  }
}
.table_img {
  width: 120px;
  height: 80px;
  object-fit: cover;
}
.link_color {
  color: @link-color;
}
.table_btn {
  padding: 0;
  
}
.ant-form-item {
  margin-bottom: 0;
}
.space_from .ant-form-item {
  margin-bottom: 8px;
}
.margin_bottom {
  margin-bottom: 16px;
}
.order_info_wrap {
  display: flex;
  .img {
    width: 120px;
    height: 80px;
    object-fit: cover;
  }
}
.order_info {
  display: inline-block;
  line-height: normal;
  margin-left: 10px;
  .order_time {
    margin: 8px 0;
    color: #ccc;
  }
}
.ant-rate {
  line-height: normal;
  font-size: 20px;
}
.query_form {
  margin-top: 16px;
  position: relative;
  padding-right: 120px;
}
.query_btn {
  position: absolute;
  top: 0;
  right: 0;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.img_list {
  display: flex;
  flex-wrap: wrap;
  img {
    width: 30%;
    margin: 1%;
  }
}
.pagination_wrap {
  display: flex;
  justify-content: flex-end;
}
.store_ico {
  width: 14px;
  margin: -3px 4px 0 0;
}
</style>